import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { deleteMBMEquipment, getMBMIotdevices, getMBMEquipmentAlarms, getSessions } from "services/ConfigServices";
import useEquipmentsTable from "./useEquipmentsTable.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { equipmenttext, pointtext } from "variables/MBM/equipments";
import { definitionData, fieldprotocoleData, eosprotocoleData, stateData, hardwareData } from "variables/MBM/lists/equipments";
import { dico } from "variables/lists/dico";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import ViewPointDataDialog from "./ViewPointDataDialog";
import PointDialog from "./PointDialog";
import EquipmentDialog from "./EquipmentDialog.js";
import PowerIcon from '@mui/icons-material/Power';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import SignalCellularAlt2BarIcon from '@mui/icons-material/SignalCellularAlt2Bar';
import SignalCellularAlt1BarIcon from '@mui/icons-material/SignalCellularAlt1Bar';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CheckSharpIcon from '@mui/icons-material/CheckSharp';
import ViewEquipmentAlarmsDialog from "components/MBM/EquipmentAlarms/ViewEquipmentAlarmsDialog.js";

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border: solid;
  border-width: 1px;
  border-color: #EEEEEE;
  background-color: white;
  margin-top: -0.5px;
  padding-top: 5px;
  overflow-x: auto;
  width: 100%;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTEquipments = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const currentusertype = localStorage.getItem('userType');
  const mbm_admin = permis.includes("mbm_admin") && currentusertype == 1; //not in prod yet
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;


  const { gridState, refetch, setEquipments, setPoints, pointsdata, equipmentsdata, displaymethod, campaignequipmentsData } = useEquipmentsTable();

  const [currentEquipment, setCurrentEquipment] = useState(null);
  const [point, setPoint] = useState(null);
  const [iotdata, setIotdata] = useState([]);
  const [sessionsdata, setSessionsdata] = useState([]);
  const [globalsessionsdata, setGlobalsessionsdata] = useState([]);

  const [alarmsdata, setAlarmsdata] = useState([]);
  const [equipmentalarmsdata, setEquipmentalarmsdata] = useState([]);
  const [refreshAlarms, setRefreshAlarms] = useState(true);
  const [alertopen, setAlertopen] = useState(false);

  const [openEquipment, setOpenEquipment] = useState(false);
  const [openPoint, setOpenPoint] = useState(false);
  const [openPointData, setOpenPointData] = useState(false);

  useEffect(() => {
    if (chartIdGroup > 0) {
      axios
        .get(
          getMBMIotdevices(chartIdGroup),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          setIotdata(res.data.iotdevices || []);
        })
        .catch(() => { });
      axios
        .get(
          getSessions(chartIdGroup),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          setSessionsdata(res.data.sessions || []);
          setGlobalsessionsdata(res.data.globalsessions || []);
        })
        .catch(() => { });
    }
  }, [chartIdGroup]);
  const handleRefreshAlarms = () => {
    setRefreshAlarms(true);
  }
  useEffect(() => {
    if (chartIdGroup > 0) {
      if (!refreshAlarms) {
        return;
      }
      axios
        .get(
          getMBMEquipmentAlarms(chartIdGroup),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          setAlarmsdata(res.data.alarms || []);
        })
        .catch(() => { });
      setRefreshAlarms(false);
    }
  }, [chartIdGroup, refreshAlarms]);

  const classes = useStyles();

  const getBatteryStyle = (batterylevel) => {
    if (batterylevel) {
      if (batterylevel < 50) {
        return { color: "#f44336" };
      }
      else if (batterylevel < 75) {
        return { color: "#FF763A" };
      }
      else {
        return { color: "#000000" };
      }
    }
  }
  const handleClickAlertOpen = () => {
    setAlertopen(true);
  };
  const handleClickAlertClose = () => {
    setAlertopen(false);
  };
  const openalert = (row) => async () => {
    let eqalarms = alarmsdata.filter((al) => al.equipment === row.id);
    if (eqalarms) {
      setEquipmentalarmsdata(eqalarms);
      handleClickAlertOpen();
    }
  };

  const equipmentscolumns = [
    {
      name: equipmenttext.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: equipmenttext.definition,
      selector: (row) => row.definition,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => definitionData.find((x) => x.id == row.definition)?.name || ""
    },
    {
      name: equipmenttext.hardware,
      selector: (row) => row.otherproperties?.hardware ? hardwareData.find((a) => a.id == row.otherproperties.hardware)?.name || equipmenttext.undefinedhardware : equipmenttext.undefinedhardware,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.otherproperties?.hardware ? hardwareData.find((a) => a.id == row.otherproperties.hardware)?.name || equipmenttext.undefinedhardware : equipmenttext.undefinedhardware
    },
    {
      name: equipmenttext.fieldprotocol,
      selector: (row) => row.connectionproperties?.fieldProtocol,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => fieldprotocoleData.find((x) => x.id == row.connectionproperties?.fieldProtocol)?.name || ""
    },
    // {
    //   name: equipmenttext.eosprotocol,
    //   selector: (row) => row.connectionproperties?.eosprotocol,
    //   sortable: true,
    //   maxWidth: "12rem",
    //   cell: (row) => eosprotocoleData.find((x) => x.id == row.connectionproperties?.eosprotocol)?.name || ""
    // },
    {
      name: equipmenttext.lastconnection,
      selector: (row) => row.lastconnection && moment(row.lastconnection).isValid() ? row.lastconnection : 0,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.lastconnection && moment(row.lastconnection).isValid()
          ? moment(row.lastconnection).format("DD/MM/YYYY HH:mm")
          : "",
    },
    {
      name: equipmenttext.iot,
      selector: (row) => iotdata.find((x) => x.id == row.connectionproperties?.iotdevice)?.name || "",
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => {
        let iot = iotdata.find((x) => x.id == row.connectionproperties?.iotdevice);
        if (iot) {
          return <Tooltip title={"deveui : " + iot.connectionproperties?.deveui + ", id : " + iot.id}>{iot.name}</Tooltip>;
        }
        else return "N/A"
      }
    },
    {
      name: equipmenttext.iotbattery,
      selector: (row) => {
        let iot = iotdata.find((x) => x.id == row.connectionproperties?.iotdevice);
        let display = 0;
        if (iot) {
          if (iot?.status?.externalpowersource === 'true')
            display = 100;
          else if (iot.status.deviceStatusbatterylevel)
            display = iot.status.deviceStatusbatterylevel;
        }
        return display;
      },
      sortable: true,
      maxWidth: "6rem",
      cell: (row) => {
        let iot = iotdata.find((x) => x.id == row.connectionproperties?.iotdevice);
        let display = "";
        if (iot) {
          if (iot?.status?.externalpowersource === 'true') {
            display = <><PowerIcon fontSize="medium" /></>;
          }
          else {
            if (iot.status.deviceStatusbatterylevel)
              display = <div style={getBatteryStyle(iot.status.deviceStatusbatterylevel)}>{iot.status.deviceStatusbatterylevel + '%'}</div>;
          }
        }
        else
          display = 'N/A';
        return display;
      }
    },
    {
      name: equipmenttext.iotsignal,
      selector: (row) => {
        let iot = iotdata.find((x) => x.id == row.connectionproperties?.iotdevice);
        let display = -999;
        if (iot?.status?.margin != null) {
          display = iot.status.margin;
        }
        return display;
      },
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => {
        let iot = iotdata.find((x) => x.id == row.connectionproperties?.iotdevice);
        let display = "";
        if (!iot)
          display = 'N/A';
        else if (iot?.status?.margin != null) {
          if (iot.status.margin >= 0) {
            display = <Tooltip title={iot.status.margin + " db"}><SignalCellularAltIcon sx={{ color: "#91c241" }} fontSize="medium" /></Tooltip>;
          }
          else if (iot.status?.margin >= -10) {
            display = <Tooltip title={iot.status.margin + " db"}><SignalCellularAlt2BarIcon sx={{ color: "#FF763A" }} fontSize="medium" /></Tooltip>;
          }
          else {
            display = <Tooltip title={iot.status.margin + " db"}><SignalCellularAlt1BarIcon sx={{ color: "#f44336" }} fontSize="medium" /></Tooltip>;
          }
        }
        return display;
      }
    },
    {
      name: equipmenttext.alarms,
      selector: (row) => alarmsdata?.find((al) => (al.equipment === row.id && al.closed === 0 && !(al.acquitment?.acquited === "yes"))) ? 2
        : alarmsdata?.find((al) => (al.equipment === row.id && al.closed === 0 && !(al.acquitment?.acquited === "yes"))) ? 1
          : 0,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => <div style={{ cursor: 'pointer' }} onClick={openalert(row)}>{
        alarmsdata?.find((al) => (al.equipment === row.id && al.closed === 0 && !(al.acquitment?.acquited === "yes"))) ?
          <Tooltip title={equipmenttext.activealarms}><NotificationsActiveIcon sx={{ color: "#f44336" }} fontSize="medium" /></Tooltip>
          : alarmsdata?.find((al) => (al.equipment === row.id && al.closed === 0 && !(al.acquitment?.acquited === "yes"))) ?
            <Tooltip title={equipmenttext.nonacquitedalarms}><NotificationsIcon sx={{ color: "#FF763A" }} fontSize="medium" /></Tooltip>
            : <Tooltip title={equipmenttext.noalarms}><CheckSharpIcon sx={{ color: "#91c241" }} fontSize="medium" /></Tooltip>
      }</div>
    },
    {
      name: equipmenttext.group,
      selector: (row) => row.groupid,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => groupInfoListById["" + row.groupid] || ""
    },
    // {
    //   name: equipmenttext.campaigngroup,
    //   selector: (row) => row.id,
    //   sortable: false,
    //   maxWidth: "10rem",
    //   cell: (row) => campaignequipmentsData.find((x) => x.equipmentid == row.id)?.parameters?.localization || ""
    // },
    {
      name: "",
      sortable: false,
      width: "10rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>{mbm_admin && (
          <div className="actions-right">
            <Tooltip title="Editer l'équipement">
              <Button
                onClick={editEquipment(row)}
                color={"warning"}
                className={classes.actionButton}
              >
                <EditIcon fontSize="large" />
              </Button>
            </Tooltip>

            <Tooltip title="Supprimer l'équipement">
              <CustomDeleteButton
                deleteTitle={"Suppression de l'équipement"}
                deleteSubTitle={`Êtes-vous sûr de vouloir supprimer l'équipement' ${row.name}?`}
                handleSupprimer={deleteEquipmentFunction(row)}
              />
            </Tooltip>

          </div>
        )}
        </>
      ),
    },
  ];

  const pointscolumns = [
    {
      name: pointtext.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: pointtext.definition,
      selector: (row) => row.definition,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => dico.find((x) => x.id == row.definition)?.name || ""
    },
    {
      name: pointtext.state,
      selector: (row) => row.state,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => stateData.find((x) => x.id == row.state)?.name || ""
    },
    {
      name: pointtext.equipment,
      selector: (row) => row.equipment,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => equipmentsdata.find((x) => x.id == row.equipment)?.name || ""
    },
    {
      name: pointtext.lastdate,
      selector: (row) => row.lastdate,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.lastdate && moment(row.lastdate).isValid()
          ? moment(row.lastdate).utc().format("DD/MM/YYYY HH:mm")
          : "",
    },
    {
      name: pointtext.lastvalue,
      selector: (row) => row.lastvalue,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.lastvalue ? isNaN(row.lastvalue.replace(",", ".")) ? row.lastvalue : new Intl.NumberFormat('fr-FR').format(row.lastvalue.replace(",", ".")) : ""
    },
    {
      name: pointtext.unit,
      selector: (row) => row.definition,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => dico.find((x) => x.id == row.definition)?.unit || ""
    },
    {
      name: pointtext.group,
      selector: (row) => row.groupid,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => groupInfoListById["" + row.groupid] || ""
    },
    {
      name: "",
      sortable: false,
      width: "10rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>

          <div className="actions-right">

            <Tooltip title="Voir les données">
              <Button
                onClick={viewPointData(row)}
                color={"info"}
                className={classes.actionButton}
              >
                <VisibilityIcon fontSize="large" />
              </Button>
            </Tooltip>
            {mbm_admin && (
              <Tooltip title="Editer le point">
                <Button
                  onClick={editPoint(row)}
                  color={"warning"}
                  className={classes.actionButton}
                >
                  <EditIcon fontSize="large" />
                </Button>
              </Tooltip>
            )}
          </div>
        </>
      ),
    },
  ];

  const viewPointData = (row) => async () => {
    let obj = pointsdata.find((o) => o.id === row.id);
    setPoint(obj);
    handleViewPointDataOpen();
  };
  const editPoint = (row) => async () => {
    let obj = pointsdata.find((o) => o.id === row.id);
    let eq = equipmentsdata.find((o) => o.id === row.equipment);
    if (obj) {
      obj.equipmentName = eq.name;
      setPoint(obj);
      handleViewPointOpen();
    }
  }
  const editEquipment = (row) => async () => {
    let obj = equipmentsdata.find((o) => o.id === row.id);
    if (obj) {
      setCurrentEquipment(obj);
      handleViewEquipmentOpen();
    }
  }

  const deleteEquipmentFunction = (row) => async () => {
    let obj = equipmentsdata.find((o) => o.id === row.id);
    let idSelected = obj.id;
    axios
      .delete(deleteMBMEquipment(idSelected),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `L'équipement a été supprimé`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const ExpandableComponent = props => {
    const { data } = props;
    const datadisplay = pointsdata.filter((x) => x.equipment === data.id);

    return (
      <Container>
        <DataTable
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
          noDataComponent={<NoData>Aucun Point à afficher</NoData>}
          noHeader={true}
          columns={pointscolumns}
          persistTableHead
          data={datadisplay}
          striped={true}
        //theme="solarized"
        />
      </Container>
    );
  };

  const conditionalRowStylesGroup = [
    {
      when: row => !row.lastconnection,
      style: {
        backgroundColor: '#CFCFD8',
      },
    },
    {
      when: row => row.lastconnection && moment(row.lastconnection).isValid() && moment(row.lastconnection) < moment().add(-1, 'd'),
      style: {
        backgroundColor: '#F44336',
      },
    },
  ];
  const conditionalRowStylesPoints = [
  ];

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    if (displaymethod === 'equipments')
      setEquipments(selection.selectedRows);
    else if (displaymethod === 'points')
      setPoints(selection.selectedRows);
  };


  const handleViewPointDataOpen = () => {
    setOpenPointData(true);
  };
  const handleViewPointDataClose = () => {
    setOpenPointData(false);
  };
  const handleViewPointOpen = () => {
    setOpenPoint(true);
  };
  const handleViewPointClose = () => {
    setOpenPoint(false);
  };
  const handleViewEquipmentOpen = () => {
    setOpenEquipment(true);
  };
  const handleViewEquipmentClose = () => {
    setOpenEquipment(false);
  };


  return (
    <>
      <DataTable
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        noDataComponent={<NoData>Aucun équipement à afficher</NoData>}
        noHeader={true}
        columns={displaymethod === 'equipments' ? equipmentscolumns : displaymethod === 'points' ? pointscolumns : []}
        persistTableHead
        pagination
        subHeader
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        expandOnRowClicked={displaymethod === 'equipments'}
        expandableRows={displaymethod === 'equipments'}
        expandableRowDisabled={(row) => row.disabled}
        expandableRowsComponent={ExpandableComponent}
        conditionalRowStyles={displaymethod === 'equipments' ? conditionalRowStylesGroup : conditionalRowStylesPoints}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleViewEquipmentClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="lg"
        open={openEquipment}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleViewEquipmentClose}>
          Edition de {currentEquipment?.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <EquipmentDialog
            equipment={currentEquipment}
            closeModal={handleViewEquipmentClose}
            refetch={refetch}
            setNotification={setNotification}
            iotdata={iotdata}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleViewPointClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="xl"
        open={openPoint}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleViewPointClose}>
          Edition de {point?.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <PointDialog
            point={point}
            closeModal={handleViewPointClose}
            refetch={refetch}
            setNotification={setNotification}
            equipmentsdata={equipmentsdata}
            sessionsdata={sessionsdata}
            globalsessionsdata={globalsessionsdata}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleViewPointDataClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openPointData}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleViewPointDataClose}>
          Données de {point?.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <ViewPointDataDialog
            point={point}
            closeModal={handleViewPointDataClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleClickAlertClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        inputProps={{
          name: 'max-width',
          id: 'max-width',
        }}
        maxWidth="xl"
        open={alertopen}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleClickAlertClose}>
          {equipmenttext.alarms}
        </CustomDialogTitle>
        <DialogContent dividers>
          <ViewEquipmentAlarmsDialog
            alarmsdata={equipmentalarmsdata}
            closeModal={handleClickAlertClose}
            refetch={handleRefreshAlarms}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTEquipments;
